import client from './client';
import qs from 'qs';

const attendUrl = '/api/v1/hr/attend';
const leaveRequestUrl = '/api/v1/hr/leave-requests';
const workScheduleUrl = '/api/v1/hr/work-schedules';
const holidayUrl = '/api/v1/hr/holidays';
const approvalV2Url = '/api/v1/common/approval/v2';

// ============================= 출퇴근 =============================

export const checkInToday = () => client.post(`${attendUrl}/today/check-in`);

export const getAttendList = (params) => {
  const queryString = qs.stringify(params);
  return client.get(`${attendUrl}/list?${queryString}`);
};

export const getAttend = (attendUuid) => {
  return client.get(`${attendUrl}/info/${attendUuid}`);
};

export const addAttend = (data) => {
  return client.post(`${attendUrl}/info`, data);
};

export const editAttend = (attendUuid, data) => {
  return client.put(`${attendUrl}/info/${attendUuid}`, data);
};

export const checkOutToday = (manual = false) => {
  return client.post(`${attendUrl}/today/check-out`, null, { params: { manual } });
};

export const removeAttend = (attendUuid) => {
  return client.delete(`${attendUrl}/info/${attendUuid}`);
};

// ============================= 근무표 =============================

export const getWorkShifts = () => {
  return client.get(`${workScheduleUrl}/shifts`);
};

export const getMyWorkSchedules = (params) => {
  const queryString = qs.stringify(params);
  return client.get(`${workScheduleUrl}/my?${queryString}`);
};

export const saveMyWorkSchedules = (data) => {
  return client.post(`${workScheduleUrl}/my`, data);
};

export const getMyWorkScheduleRequests = (params) => {
  const queryString = qs.stringify(params);
  return client.get(`${workScheduleUrl}/requests/my?${queryString}`);
};

export const getWorkScheduleRequestInbox = (params) => {
  const queryString = qs.stringify(params);
  return client.get(`${workScheduleUrl}/requests/inbox?${queryString}`);
};

export const submitWorkScheduleChangeRequest = (data) => {
  return client.post(`${workScheduleUrl}/requests`, data);
};

export const cancelWorkScheduleChangeRequest = (reqId) => {
  return client.post(`${workScheduleUrl}/requests/${reqId}/cancel`);
};

export const confirmWorkScheduleChangeRequest = (reqId) => {
  return client.post(`${workScheduleUrl}/requests/${reqId}/confirm`);
};

export const rejectWorkScheduleChangeRequest = (reqId) => {
  return client.post(`${workScheduleUrl}/requests/${reqId}/reject`);
};

export const getHolidays = (params) => {
  const queryString = qs.stringify(params);
  return client.get(`${holidayUrl}?${queryString}`);
};

export const saveHoliday = (data) => {
  return client.post(holidayUrl, data);
};

export const collectHolidays = (data) => {
  return client.post(`${holidayUrl}/collect`, data);
};

// ============================= 휴가 =============================

export const getLeaveList = (params) => {
  const queryString = qs.stringify(params);
  return client.get(`${attendUrl}/leave/list?${queryString}`);
};

export const getLeave = (leaveUuid) => {
  return client.get(`${attendUrl}/leave/info/${leaveUuid}`);
};

export const addLeave = (data) => {
  return client.post(`${attendUrl}/leave/info`, data);
};

export const editLeave = (leaveUuid, data) => {
  return client.put(`${attendUrl}/leave/info/${leaveUuid}`, data);
};

export const removeLeave = (leaveUuid) => {
  return client.delete(`${attendUrl}/leave/info/${leaveUuid}`);
};

// ============================= 휴가 신청 =============================

export const getMyLeaveRequests = (params) => {
  const queryString = qs.stringify(params);
  return client.get(`${leaveRequestUrl}/my?${queryString}`);
};

export const getLeaveApprovalInbox = (params) => {
  const queryString = qs.stringify(params);
  return client.get(`${leaveRequestUrl}/inbox?${queryString}`);
};

export const getLeaveRequest = (leaveReqId) => {
  return client.get(`${leaveRequestUrl}/${leaveReqId}`);
};

export const submitLeaveRequest = (data) => {
  return client.post(`${leaveRequestUrl}`, data);
};

export const approveLeaveRequest = (leaveReqId, data) => {
  return client.post(`${leaveRequestUrl}/${leaveReqId}/approve`, data);
};

export const rejectLeaveRequest = (leaveReqId, data) => {
  return client.post(`${leaveRequestUrl}/${leaveReqId}/reject`, data);
};

export const recallLeaveRequest = (leaveReqId) => {
  return client.post(`${leaveRequestUrl}/${leaveReqId}/recall`);
};

// ============================= 대결 관리 =============================

export const getMyDelegations = () => {
  return client.get(`${approvalV2Url}/delegations/my`);
};

export const addDelegation = (data) => {
  return client.post(`${approvalV2Url}/delegations`, data);
};

export const editDelegation = (delegationId, data) => {
  return client.put(`${approvalV2Url}/delegations/${delegationId}`, data);
};

export const removeDelegation = (delegationId) => {
  return client.delete(`${approvalV2Url}/delegations/${delegationId}`);
};

// ============================= KPI =============================

export const getNonWorkSummary = (params) => {
  const queryString = qs.stringify(params);
  return client.get(`${attendUrl}/kpi/nonwork?${queryString}`);
};
